"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getYoutubeEmbedUrl;
var _is_present = _interopRequireDefault(require("./is_present"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function getYoutubeEmbedUrl(youtubeUrl) {
  if ((0, _is_present["default"])(youtubeUrl)) {
    var match = /(?:watch\?v=|^https:\/\/youtu\.be\/)(...........)/.exec(youtubeUrl);
    if (match) {
      return "https://www.youtube.com/embed/".concat(match[1]);
    }
  }
  return youtubeUrl;
}